import { JSX } from 'react'

import { IconProps } from '../../icon'

const Home: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M37.0237 16.2649L30.1039 10.0889C26.9899 7.30369 22.2844 7.30369 19.1705 10.0889L12.2506 16.2649C10.5034 17.8219 9.5 20.0535 9.5 22.4063V33.4088C9.5 37.0418 12.4063 40 15.9874 40H33.287C36.868 40 39.7744 37.0418 39.7744 33.4088V22.4063C39.7744 20.0708 38.771 17.8219 37.0237 16.2649ZM28.5296 37.3878H20.7448V31.7654C20.7448 29.6202 22.492 27.873 24.6372 27.873C26.7823 27.873 28.5296 29.6202 28.5296 31.7654V37.3878ZM37.1794 33.3915C37.1794 35.5886 35.4321 37.3878 33.287 37.3878H31.1245V31.7654C31.1245 28.1843 28.2182 25.278 24.6372 25.278C21.0562 25.278 18.1498 28.1843 18.1498 31.7654V37.3878H15.9874C13.8422 37.3878 12.0949 35.6059 12.0949 33.3915V22.389C12.0949 20.7801 12.7869 19.2577 13.9806 18.1852L20.9005 12.0092C23.0283 10.1062 26.246 10.1062 28.3739 12.0092L35.2938 18.1852C36.4874 19.2577 37.1794 20.7801 37.1794 22.389V33.3915Z'
      fill='black'
    />
  </svg>
)

export default Home
